import { Userpilot } from 'userpilot';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type UserPilotEvents =
  | 'proposal_sent'
  | 'Clicked NOT ACCURATE on auto-populated revenue data'
  | 'Clicked VALIDATE on auto-populated revenue data';

type UserPilotPrimitives = string | number | boolean | null;
type MetaPayload = Record<string, UserPilotPrimitives>;

export interface UserPilotPayload {
  event: UserPilotEvents;
  metadata?: MetaPayload;
}

export function useUserPilot() {
  const handleTrackEvent = useCallback((dto: UserPilotPayload) => {
    const { event, metadata } = dto;

    Userpilot.track(event, metadata);
  }, []);

  return {
    handleTrackEvent,
  };
}

// Userpilot must be reloaded on every route change in SPAs so it re-evaluates content for the new page.
export function useUserPilotReload(isAuthenticated: boolean) {
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      Userpilot.reload();
    }
  }, [location, isAuthenticated]);
}
